import { bulkUploadDataValidationInterfaceInstance } from 'Interfaces/FactsInterfaces/tmsInterfaces';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { factScreenServices } from 'services/factsScreenServices';

let frontendUrl;
if (import.meta.env.VITE_MODE == 'dev') {
  frontendUrl = import.meta.env.VITE_FRONTEND_ENDPOINT;
} else {
  frontendUrl = window.config.frontendBaseUrl;
}

const useBulkTmsModalUploadAndValidation = () => {
  const [fileUploaded, setFiledUploaded] = useState(false);
  const [validationData, setValidationData] = useState<bulkUploadDataValidationInterfaceInstance[]>(
    []
  );

  const [isFileUploading, setIsFileUploading] = useState(false);

  const handleDownloadTemplate = () => {
    // Step 3: Create a link element
    const link = document.createElement('a');
    if (frontendUrl.length && frontendUrl[frontendUrl.length - 1] === '/') {
      link.href = `${frontendUrl}bd-portal/bulk-tms-upload-template.xlsx`;
    } else {
      link.href = `${frontendUrl}/bd-portal/bulk-tms-upload-template.xlsx`;
    }
    link.download = `bulk-tms-upload-template.xlsx`; // Name of the file to download
    // Step 4: Append the link to the DOM, trigger click, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fileUploadCallback = (data: bulkUploadDataValidationInterfaceInstance[]) => {
    setFiledUploaded(true);
    setValidationData(data);
  };

  const handleUploadFile = async (file: File) => {
    if (file) {
      try {
        setIsFileUploading(true);
        const formData = new FormData();
        formData.append('file', file);
        const preview_response = await factScreenServices.getTmsBulkUpdatePreviewData(formData);
        // handleUploadCallBack(preview_response["data"]);
        setValidationData(preview_response.data);
        setFiledUploaded(true);
      } catch (_err) {
        toast.error(
          'The data file uploaded is not in the correct expected format, please verify it once and then upload'
        );
      } finally {
        setIsFileUploading(false);
      }
    }
  };

  return {
    fileUploaded,
    fileUploadCallback,
    validationData,
    handleDownloadTemplate,
    isFileUploading,
    handleUploadFile,
  };
};

export default useBulkTmsModalUploadAndValidation;
